import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Card } from "primereact/card";
import { SpeedDial } from "primereact/speeddial";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { ScrollPanel } from "primereact/scrollpanel";
import { TabView, TabPanel } from "primereact/tabview";
import { Divider } from "primereact/divider";

const News = ({ customerId }) => {

    const [news, setNews] = React.useState([]);

  return (
    <div className="h-full">
      <div
        className="shadow-2 p-3 h-full flex flex-column"
        style={{ borderRadius: "6px" }}
      >
        <div className="text-900 font-medium text-xl mb-2">News</div>
        <ScrollPanel style={{ height: "500px" }}>
        {(news && news.length > 0) ? news.map(item =>
            <p className="m-1">
            (item.Summary)
          </p>
        ):
        <p>No News</p>}
        </ScrollPanel>
      </div>
    </div>
  );
};

export default News;
